import React, { useContext } from "react";
import { ConfigurationContext } from '../context/ConfigurationContext'
import { UserContext } from '../context/UserContext'
import Container from '../components/containers/Container'
import { v4 as uuidv4 } from 'uuid';

const ConfirmationView = () => {
  const { configurations } = useContext(ConfigurationContext);
  const { 
    type,
    vehicle,
    getAnswers,
    configurationId,
  } = useContext(UserContext);

  const currentProduct = configurations.items.find( item => item.id === parseInt(configurationId));
  const questions      = currentProduct.fields;

  // Array for single answers
  let answers = [];
  let answersIndex = 0;
  // Array for multiple answers
  let answersMultiple = [];
  let answersMultipleIndex = 0;
  // Array for questions with multple answers
  let questionsMultiple = [];
  let questionsMultipleIndex = 0;

  const confirmation  = configurations.items.find( item => item.fordonstyp === 'confirmation' );

  // Answers
  for ( let i = 0; i < getAnswers().length; i++ ) {
    const answer = getAnswers()[i]['answer'];

    if( typeof answer === 'string' || typeof answer === 'number' ) {
      answers[answersIndex] = answer;
      answersIndex++;
    } else if( typeof answer === 'object' ) {
      for ( let i2 = 0; i2 < answer.length; i2++ ) {
        const title = answer[i2]['title'];
        const options = answer[i2]['options'];
        let answerString = '';
        questionsMultiple[questionsMultipleIndex] = title;
        questionsMultipleIndex++;
        
        for ( let i3 = 0; i3 < options.length; i3++ ) {
          const option = options[i3]['option'];
          const checked = options[i3]['checked'];
          
          if( checked ) {
            answerString = answerString + option + ', ';
          }
        }
        
        if( answerString ) {
          answersMultiple[answersMultipleIndex] = answerString.slice(0,-2);
          answersMultipleIndex++;
        }
      }
    }
  }

  const questionsSingle = [];
  let questionIndex = 0;

  for ( let i = 0; i < questions.length; i++ ) {
    const question = questions[i];

    if( question['type'] !== 'checkboxMulti' && question['type'] !== 'radioMulti' ) {
      questionsSingle[questionIndex] = question['heading'];
      questionIndex++;
    }
  }

  // Merge array for single answers with array for multiple answers
  const allAnswers = answers.concat(answersMultiple);
  // Merge questions
  const allQuestions = questionsSingle.concat(questionsMultiple);

  return (
    <Container>
      <div>
        <h1 className={"text-3xl sm:text-5xl font-bold mb-10"}>{confirmation.title}</h1>

        <p className={"text-base sm:text-xl mb-10"}>{confirmation.text}</p>

        <ul>
          <li className={'text-base sm:text-xl mb-2 capitalize'} key={uuidv4()}>
            <strong>{ type }</strong>
          </li>

          <li className={'text-base sm:text-xl mb-2'} key={uuidv4()}>
            <strong>{ vehicle }</strong>
          </li>
          {allAnswers.map( (a, i) => {
            return (
            <li key={uuidv4()} className="mb-2"> 
              <span className="text-base sm:text-xl">
                { allQuestions[i] + ' ' }
              </span> 
              -
              <span className="text-base sm:text-xl">
              { ' ' + a }
              </span>
            </li>)
          })}
        </ul>

      </div>
    </Container>
  );
};

export default ConfirmationView;
